export default __webpack_public_path__ + "static/media/Dexo NFT Landing.bd819ba7.gif";